import moment from 'moment';

export const chatDateFormat = (stepTs) => {
  const raw = stepTs;
  const m = moment(raw);
  if (!m.isValid()) return '';

  const now = moment();
  const isToday = m.isSame(now, 'day');
  const isYesterday = m.isSame(now.clone().subtract(1, 'day'), 'day');

  const dateLabel = isToday
    ? 'Today'
    : isYesterday
    ? 'Yesterday'
    : m.locale('en').format('MMM D, YYYY');

  return `${dateLabel} · ${m.locale('en').format('h:mm A')}`;
};
